import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent {
  /***
   Título do modal
  ***/
  @Input() title: string = '';

  /***
   Remover padding do modal
   ***/
  @Input() removePadding: boolean = false;
  /***
   Evento Fechar Modal
   ***/
  @Output() close = new EventEmitter<void>();


  onClose(): void {
    this.close.emit();
  }
}

